export interface PublicThirdPartiesDTO {
    ID: string,
    ThirdPartyAccountType: number,
    ThirdPartyAccountTypeText: string,
    ThirdPartySubledgerAccountID: string,
    ThirdPartySubledgerAccount: string,
    Code: string,
    Name: string,
    FiscalIdentificationNumber: string,
    AddressCode: string,
    DefaultTax: string,
    DefaultTaxID: string,
    Memo: string,
    CurrencyCode: string,
    NumericCode: number,
    ThirdPartyCategory: string,
    PaymentTerm: string,
    ProfitLossAccounts: Array<string>,
    ReevaluationRule: string,
    DisplayFormattedString: string,
    Iso20022PaymentInfos: Array<string>,
    AddressLocationCode: string
  }